module.exports = __webpack_public_path__ + "static/media/Discover.d2272ed3.jpg";